import { render, staticRenderFns } from "./NewUpload.vue?vue&type=template&id=f553f778&scoped=true&"
import script from "./NewUpload.vue?vue&type=script&lang=js&"
export * from "./NewUpload.vue?vue&type=script&lang=js&"
import style0 from "../assets/v2/css/trans/common.less?vue&type=style&index=0&id=f553f778&prod&lang=less&scoped=true&"
import style1 from "../assets/v2/css/trans/index.less?vue&type=style&index=1&id=f553f778&prod&lang=less&scoped=true&"
import style2 from "./NewUpload.vue?vue&type=style&index=2&id=f553f778&prod&lang=less&"
import style3 from "./NewUpload.vue?vue&type=style&index=3&id=f553f778&prod&lang=less&"
import style4 from "./NewUpload.vue?vue&type=style&index=4&id=f553f778&prod&lang=less&"
import style5 from "./NewUpload.vue?vue&type=style&index=5&id=f553f778&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f553f778",
  null
  
)

export default component.exports